import BulkActionsConfirmActionStepInlineConfirmation from "components/BulkActions/ConfirmActionStep/InlineConfirmation";

import { ApiKeyRolesBulkActionsConfirmActionStepProps } from "./types";

type ApiKeyRolesBulkActionsConfirmActionStepDefaultProps = ApiKeyRolesBulkActionsConfirmActionStepProps;

const ApiKeyRolesBulkActionsConfirmActionStepDefault = ({
  action,
  bulkActionsVariant,
  onConfirm,
  onCancel,
  customConfirmationMessage,
}: ApiKeyRolesBulkActionsConfirmActionStepDefaultProps) => {
  return (
    <BulkActionsConfirmActionStepInlineConfirmation
      variant={bulkActionsVariant}
      actionLabel={action.title.toLowerCase()}
      onConfirm={() =>
        onConfirm(null, {
          view: bulkActionsVariant,
          metadata: {},
        })
      }
      onCancel={onCancel}
      customConfirmationMessage={customConfirmationMessage}
    />
  );
};

export default ApiKeyRolesBulkActionsConfirmActionStepDefault;